export const boardResourcesTour = {
  key: "boardResources",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-resources-assign"]',
      content: t("Tour_BoardResources_Assign"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-resources-alert"]',
      content: t("Tour_BoardResources_Alert"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-resources-timeline"]',
      content: t("Tour_BoardResources_Timeline"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-resources-add"]',
      content: t("Tour_BoardResources_Add"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-resources-card"]',
      content: t("Tour_BoardResources_Categories"),
      placement: "top",
    },
  ],
};
